var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from '../../user/index.js';
import { Difficulty } from '../enums/difficulty.enum.js';
import { Visibility } from '../enums/visibility.enum.js';
import { BodyRegionFullSizeDto } from './body-region.full-size.dto.js';
import { ExercisePackageFullSizeDto } from './exercise-package.full-size.dto.js';
export class ExerciseFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    filename;
    thumbFilename;
    originalFilename;
    shotNo;
    text;
    indication;
    duration;
    exerciseProgramItems;
    exerciseDeviceItems;
    deviceText;
    weightNeeded;
    difficulty;
    visibility;
    exercisePackages;
    exercisePackageIds;
    bodyRegions;
    bodyRegionIds;
    positiveRatingCount;
    negativeRatingCount;
    avgRating;
    uploadedById;
    uploadedBy;
    sharedWithUserId;
    sharedWithUser;
    sharedWithOfficeId;
    sharedWithOffice;
    exerciseFavourites;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "filename", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "thumbFilename", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "originalFilename", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "shotNo", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "text", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "indication", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseFullSizeDto.prototype, "duration", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "exerciseProgramItems", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "exerciseDeviceItems", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "deviceText", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseFullSizeDto.prototype, "weightNeeded", void 0);
__decorate([
    IsEnum(Difficulty),
    Expose(),
    __metadata("design:type", String)
], ExerciseFullSizeDto.prototype, "difficulty", void 0);
__decorate([
    IsEnum(Visibility),
    Expose(),
    __metadata("design:type", String)
], ExerciseFullSizeDto.prototype, "visibility", void 0);
__decorate([
    IsArray(),
    Type(() => ExercisePackageFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "exercisePackages", void 0);
__decorate([
    IsArray(),
    IsUUID(undefined, { each: true }),
    Expose(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "exercisePackageIds", void 0);
__decorate([
    IsArray(),
    Type(() => BodyRegionFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "bodyRegions", void 0);
__decorate([
    IsArray(),
    IsUUID(undefined, { each: true }),
    Expose(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "bodyRegionIds", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseFullSizeDto.prototype, "positiveRatingCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseFullSizeDto.prototype, "negativeRatingCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseFullSizeDto.prototype, "avgRating", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.THERAPIST, Role.ADMIN, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "uploadedById", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], ExerciseFullSizeDto.prototype, "uploadedBy", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "sharedWithUserId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], ExerciseFullSizeDto.prototype, "sharedWithUser", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseFullSizeDto.prototype, "sharedWithOfficeId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Function)
], ExerciseFullSizeDto.prototype, "sharedWithOffice", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], ExerciseFullSizeDto.prototype, "exerciseFavourites", void 0);
//# sourceMappingURL=exercise.full-size.dto.js.map